import {usePageTitle} from "../../../common/hooks";
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import React, {useState} from "react";
import {GamePageState} from "../../../common/utils/pageState";
import {GameInfoComponent} from "../../../common/components/game-info/GameInfoComponent";
import {LINES_GAME as GAME} from "../../../common/utils/games";
import LinesGameConfig from "./components/LinesGameConfig";
import LinesGamePlay from "./components/LinesGamePlay";
import {IGameDescription, Localised} from "../../../common/types";
import {getCurrentLang} from "../../../common/utils/lang";

const gameDescription:Localised<IGameDescription> = require("./description.json");

const LinesGamePage = () => {
    usePageTitle("games.lines.name");
    const [page, setPage] = useState<GamePageState>(GamePageState.INFO);
    const [lines, setLines] = useState<string[]>([]);

    const pageChangeClick = (targetState: GamePageState) => () => {
        setPage(targetState);
    };

    const activeLang = getCurrentLang();
    const infoPage = <GameInfoComponent game={GAME} description={gameDescription[activeLang]} nextClick={pageChangeClick(GamePageState.CONFIG)}/>;
    const configPage = <LinesGameConfig
        backToDetails={pageChangeClick(GamePageState.INFO)}
        nextToPlay={pageChangeClick(GamePageState.PLAY)}
        lines={lines}
        setLines={setLines}
    />;
    const playPage = <LinesGamePlay
        showConfig={pageChangeClick(GamePageState.CONFIG)}
        showInfo={pageChangeClick(GamePageState.INFO)}
        lines={lines}
    />;

    const displayedPage = page === GamePageState.INFO ? infoPage : (page === GamePageState.CONFIG ? configPage : playPage);

    return (
        <PageContainer fixedHeaderFooter={true}>
            {displayedPage}
        </PageContainer>
    )
};

export default LinesGamePage;
